import React from 'react'
import { PersonCard } from './PersonCard'
import { Person, AssistantConnection } from '../types/profile'

interface OrgGridProps {
  people: Person[]
  onPersonSelect?: (person: Person) => void
  onMessage?: (person: Person) => void
  selectedPersonId?: string
  currentUserAccessList?: AssistantConnection[]
}

export const OrgGrid: React.FC<OrgGridProps> = ({
  people,
  onPersonSelect,
  onMessage,
  selectedPersonId,
  currentUserAccessList = [],
}) => {
  if (people.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No people found</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {people.map((person) => (
        <div
          key={person.id}
          onClick={() => onPersonSelect?.(person)}
          className="cursor-pointer"
        >
          <PersonCard
            person={person}
            variant={selectedPersonId === person.id ? 'highlighted' : 'compact'}
            onMessage={onMessage}
          />
        </div>
      ))}
    </div>
  )
}


